import { AuthenticatedRequest, HTTPMethod, APIVersion, Session } from "../requests/request";


export interface UsageReportingItem {
    id: number;
    month_year: string;
    subscription?: string;
    country?: string;
    album_name: string;
    artist_name: string;
    album_id: number;
    download_count: number;
}

export interface FinancialDatasource {
    minOfAudioDelivered: number,
    totalNoOfUsers: number,
    numberOfNewUsers: number,
    totalNumberOfUniqueVisits: number,
    churn: number,
    totalPlays: number,
    totalPlaysSME: number,
    totalRoyaltyBearingPlaysAcrossAllContentProviders: number,
    totalRoyaltyBearingPlaysSME: number,
    SMEMarketShareByUsage: number,
    revenueSharePerc: number,
    monthlyActiveUserPerc: number,
    oneTimeActivationPerc: number
}

export class API {

    public static getUsageReportDatasource(month_year: string): Promise<UsageReportingItem[]> {
        let apiRequest = new AuthenticatedRequest<UsageReportingItem>('/admin/usage-reporting/datasource', HTTPMethod.GET, APIVersion.v1_2, { month_year });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }

    public static generateReport(month_year: string, index: number): Promise<{ salesUrl: string, financialUrl: string, info: Object }> {
        let apiRequest = new AuthenticatedRequest<{ url: string }>('/admin/usage-reporting/' + month_year + '/generate', HTTPMethod.POST, APIVersion.v1_2, undefined, { index });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }

    public static getFinancialReportDatasource(start_date: Date, end_date: Date): Promise<{ standard: Partial<FinancialDatasource>, premium: Partial<FinancialDatasource> }> {
        let apiRequest = new AuthenticatedRequest<any>('/financial-datasource', HTTPMethod.GET, APIVersion.adminV1, { start_date: start_date.toJSON(), end_date: end_date.toJSON() });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }

    public static generateFinancialReport({ start_date, end_date, no, premium, standard }: { start_date: Date; end_date: Date; no: number; premium: FinancialDatasource; standard: FinancialDatasource }): Promise<{ url: string }> {
        let apiRequest = new AuthenticatedRequest<{ url: string }>('/financial-report', HTTPMethod.POST, APIVersion.adminV1, { start_date: start_date.toJSON(), end_date: end_date.toJSON(), no }, { standard, premium });
        return apiRequest.send().then((response) => {
            return response.data;
        });
    }

    public static downloadFile(file: string): string {
        return `${Session.getAPIURL()}/${APIVersion.adminV1}/report-file?path=${file}`
    }

}


// WEBPACK FOOTER //
// ./src/api/src/endpoints/report.ts